<<!--  -->
<template>
  <div class="calendar-box">
    <div class="statistical">
      <div class="select-month">
        <el-date-picker
          v-model="month"
          type="month"
          placeholder="选择要查看的月份"
          size='large'
        ></el-date-picker>
      </div>
      <ul class="statistical-list">
        <li v-if="statistical.kol_count"><span>{{statistical.kol_count}}</span>位达人</li>
        <li v-if="statistical.goods_count"><span>{{statistical.goods_count}}</span>件商品</li>
        <li v-if="statistical.task_count"><span>{{statistical.task_count}}</span>次带货</li>
      </ul>
    </div>
    <div class="calendar-base">
      <el-calendar
        v-model="month"
      >
        <template
          slot="dateCell"
          slot-scope="{ data }"
        >
          <el-popover
            placement="right"
            trigger="hover"
            :disabled="!schedule[data.day]"
          >
            <ul v-if="!!schedule[data.day]" class="schedule-info">
              <li v-for="info in schedule[data.day].store" :key="info.id">
                <p class="schedule-info-title">{{info.store_name}}（{{info.platform}}）</p>
                <div v-if="info.kol" class="schedule-info-kol">
                  <div v-for="kol in info.kol" :key="kol.id">
                    <p>
                      <span>{{kol.nickname}}</span>
                      <span v-if="kol.promote_live">混播</span>
                      <span v-if="kol.promote_live_special">专场</span>
                      <span v-if="kol.promote_other">其他</span>
                      <span v-if="kol.promote_video">短视频</span>
                    </p>
                    <el-tooltip class="item" effect="dark" :content="kol.goods_name" placement="top">
                      <p>{{kol.goods_name}}</p>
                    </el-tooltip>
                    <p>带货时间&nbsp;{{kol.kol_time_begin}}—{{kol.kol_time_end}}</p>
                  </div>
                </div>

                <p v-if="info.kol_count && info.kol">还有<em>{{info.kol_count}}</em>位星罗精选达人选中您的商品，为您带货<em>{{info.task_count}}</em>场</p>
                <p v-else-if="info.kol_count">共有<em>{{info.kol_count}}</em>位星罗精选达人为您带货<em>{{info.task_count}}</em>场</p>
              </li>
            </ul>
            <div class="date-cell" slot="reference">
              <p :class="data.isSelected ? 'is-selected' : ''">
                {{ data.day.split('-').slice(1).join('-') }}
              </p>
              <ul class="schedule" v-if="schedule[data.day]">
                <li v-if="schedule[data.day].kol_count">
                  {{ schedule[data.day].kol_count }}位达人
                </li>
                <li v-if="schedule[data.day].goods_count">
                  {{ schedule[data.day].goods_count }}件商品
                </li>
                <li v-if="schedule[data.day].task_count">
                  {{ schedule[data.day].task_count }}次带货
                </li>
              </ul>
            </div>
          </el-popover>
        </template>
      </el-calendar>
    </div>
  </div>
</template>

<script>
import utils from '@/utils/util';
import basics from "@/config/basics.js";
export default {
  name: "mycalendar",
  data() {
    return {
      statistical: {},
      month: new Date(),
      schedule: {},
    };
  },
  components: {},
  created() {
    this.getData();
  },
  watch: {
    month(month) {
      let date = utils.dateFormat(month);
      month = `${date.year}-${date.month}`;
      this.getData(month);
    }
  },
  mounted() {},
  methods: {
    getData(month) {
      let date = utils.dateFormat(new Date());
      month = month || `${date.year}-${date.month}`;
      let _that = this;
      this.$http({
        method: 'GET',
        params: { month },
        url: '/home/getCalendarKolGoodsList'
      }).then(res => {
        if (res.code !== 1) {
          console.error(res.msg);
          return false;
        }
        // 数据格式化
        res.data.list && _that.formatStatisticalData(res.data.list);
        res.data.list && _that.formatScheduleData(res.data.list);
      }).catch(error => {
        console.error(error);
      });
    },
    formatStatisticalData(data) {
      this.statistical = {
        kol_count: data.kol_count,
        task_count: data.task_count,
        goods_count: data.goods_count,
      };
      // 接口样式变更，之前格式先保留
      // this.statistical = {
      //   live: {
      //     ing: data.promote_live_ing_count,
      //     count: data.promote_live_count,
      //   },
      //   video: {
      //     ing: data.promote_video_ing_count,
      //     count: data.promote_video_count,
      //   },
      //   other: {
      //     ing: data.promote_other_ing_count,
      //     count: data.promote_other_count,
      //   },
      //   hybrid: {
      //     ing: data.promote_live_special_ing_count,
      //     count: data.promote_live_special_count,
      //   },
      // };
    },
    formatScheduleData(list) {
      let schedule = {};
      let date = utils.dateFormat(this.month);
      let month = `${date.year}-${date.month}`;
      Object.keys(list)
      .filter(v => v!= 'kol_count' && v!= 'task_count' && v!= 'goods_count' )
      .forEach(day => {
        schedule[`${month}-${day}`] = list[day];
        schedule[`${month}-${day}`].store = Object.keys(list[day].store).map(storeID => {
          let store = { ...list[day].store[storeID] };
          store.id = storeID;
          store.platform = basics.platform_obj[list[day].store[storeID].platform];
          store.kol = list[day].store[storeID].kol && Object.keys(list[day].store[storeID].kol).map(kolID => {
            let kol = list[day].store[storeID].kol[kolID];
            kol.id = kolID;
            kol.kol_time_begin = kol.kol_time_begin ? kol.kol_time_begin.split(' ')[0] : '';
            kol.kol_time_end = kol.kol_time_end ? kol.kol_time_end.split(' ')[0] : '';
            return kol;
          });
          return store;
        });
      });
      this.schedule = schedule;
    },
  },
};
</script>
<style scoped>
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.calendar-box {
  padding: 20px;
}
.calendar-box:before ,.calendar-box:after {
  content: '';
  clear: both;
  display: block;
  height: 0;
  width: 0;
}
.select-month ,.statistical-list {
  display: inline-block;
}
.statistical-list {
  margin-left: 40px;
}
.statistical-list > li {
  display: inline-block;
  margin-right: 16px;
  cursor: default;
}
.calendar-base >>> .el-calendar-table .el-calendar-day {
  height: 120px;
  overflow: hidden;
}
.schedule-info {
  max-height: 80vh;
  overflow: auto;
}
.schedule-info-title {
  font-weight: bold;
}
.schedule-info-kol div {
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
  margin: 16px;
}
.schedule-info-kol p {
  margin: 5px 0;
  max-width: 330px;
  overflow: hidden;    
  text-overflow:ellipsis;    
  white-space: nowrap;  
}
.schedule-info-kol p:first-child {
  padding-right: 30px;
  max-width: 300px;
}

.schedule-info-kol p span:first-child {
  float: none;
  max-width: 80px;
  display: inline-block;
  overflow: hidden;    
  text-overflow:ellipsis;    
  white-space: nowrap;
}
.schedule-info-kol p span {
  float: right;
}
.schedule-info-kol p span ~ span ~ span::after {
  content: '/';
}
.schedule-info p em {
  font-size: 20px;
  margin: 0 2px;
  font-weight: bold;
}
.calendar-base .date-cell {
  height: 100%;
  width: 100%;
}
.calendar-base .date-cell p {
  margin: 5px;
}
.calendar-base .date-cell .schedule li {
  font-size: 14px;
}
</style>